module.exports = __webpack_public_path__ + "img/newsHomeAdWhite.30ccaca1.png";